<ion-card
  class="container"
  (click)="emitButtonClick.emit()"
  onkeypress="emitButtonClick.emit()"
>
  <ion-row class="row">
    <ion-col
      class="text ion-no-padding"
      [size]="hasDownloadIcon || hasArrowIcon ? 11 : 12"
    >
      {{ buttonText }}
    </ion-col>
    @if (hasDownloadIcon) {
      <ion-col [size]="1" class="icon-col">
        <ion-icon class="icon" [src]="IMAGES.DOWNLOAD"></ion-icon>
      </ion-col>
    }
    @if (hasArrowIcon) {
      <ion-col [size]="1" class="icon-col arrow-icon-col">
        <ion-icon class="icon" [src]="IMAGES.ARROW_RIGHT"></ion-icon>
      </ion-col>
    }
  </ion-row>
</ion-card>
